document.addEventListener("DOMContentLoaded", () => {
  const productGalleries = {
    "snow-washed-oversized-cotton-t-shirt": {
      default: [
        { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/MineralWashWaffleKnitT-Shirt-gallery-9.jpg?v=1780339507", alt: "Mineral Wash Waffle Knit T-Shirt in black front view" },
        { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/MineralWashWaffleKnitT-Shirt-gallery-10.jpg?v=1780339509", alt: "Mineral Wash Waffle Knit T-Shirt in black back view" }
      ],
      colors: {
        black: [
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/MineralWashWaffleKnitT-Shirt-gallery-9.jpg?v=1780339507", alt: "Mineral Wash Waffle Knit T-Shirt in black front view" },
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/MineralWashWaffleKnitT-Shirt-gallery-10.jpg?v=1780339509", alt: "Mineral Wash Waffle Knit T-Shirt in black back view" }
        ],
        beige: [
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/MineralWashWaffleKnitT-Shirt-gallery-13.jpg?v=1780339507", alt: "Mineral Wash Waffle Knit T-Shirt in beige front view" },
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/MineralWashWaffleKnitT-Shirt-gallery-14.jpg?v=1780339507", alt: "Mineral Wash Waffle Knit T-Shirt in beige back view" }
        ],
        blue: [
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/MineralWashWaffleKnitT-Shirt-gallery-19.jpg?v=1780339507", alt: "Mineral Wash Waffle Knit T-Shirt in blue front view" },
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/MineralWashWaffleKnitT-Shirt-gallery-20.jpg?v=1780339507", alt: "Mineral Wash Waffle Knit T-Shirt in blue back view" }
        ],
        gray: [
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/MineralWashWaffleKnitT-Shirt-gallery-1.jpg?v=1780339507", alt: "Mineral Wash Waffle Knit T-Shirt in gray front view" },
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/MineralWashWaffleKnitT-Shirt-gallery-2.jpg?v=1780339507", alt: "Mineral Wash Waffle Knit T-Shirt in gray back view" }
        ],
        pink: [
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/MineralWashWaffleKnitT-Shirt-gallery-23.jpg?v=1780339507", alt: "Mineral Wash Waffle Knit T-Shirt in pink front view" },
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/MineralWashWaffleKnitT-Shirt-gallery-24.jpg?v=1780339507", alt: "Mineral Wash Waffle Knit T-Shirt in pink back view" }
        ],
        green: [
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/MineralWashWaffleKnitT-Shirt-gallery-21.jpg?v=1780339507", alt: "Mineral Wash Waffle Knit T-Shirt in green front view" },
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/MineralWashWaffleKnitT-Shirt-gallery-22.jpg?v=1780339507", alt: "Mineral Wash Waffle Knit T-Shirt in green back view" }
        ],
        cream: [
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/MineralWashWaffleKnitT-Shirt-gallery-11.jpg?v=1780339507", alt: "Mineral Wash Waffle Knit T-Shirt in cream front view" },
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/MineralWashWaffleKnitT-Shirt-gallery-12.jpg?v=1780339507", alt: "Mineral Wash Waffle Knit T-Shirt in cream back view" }
        ]
      }
    },
    "snow-washed-tape-raw-edge-sweatpants": {
      default: [
        { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/SnowWashedTapeRawEdgeSweatpants-gallery-19.jpg?v=1776907692", alt: "Snow Washed Tape Raw Edge Sweatpants in black front view" },
        { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/SnowWashedTapeRawEdgeSweatpants-gallery-20.jpg?v=1776907692", alt: "Snow Washed Tape Raw Edge Sweatpants in black back view" }
      ],
      colors: {
        black: [
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/SnowWashedTapeRawEdgeSweatpants-gallery-19.jpg?v=1776907692", alt: "Snow Washed Tape Raw Edge Sweatpants in black front view" },
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/SnowWashedTapeRawEdgeSweatpants-gallery-20.jpg?v=1776907692", alt: "Snow Washed Tape Raw Edge Sweatpants in black back view" }
        ],
        gray: [
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/Snow_Washed_Tape_Raw_Edge_Sweatpants-gallery-1.jpg?v=1776907703", alt: "Snow Washed Tape Raw Edge Sweatpants in gray front view" },
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/SnowWashedTapeRawEdgeSweatpants-gallery-2.jpg?v=1776907692", alt: "Snow Washed Tape Raw Edge Sweatpants in gray back view" }
        ],
        brown: [
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/SnowWashedTapeRawEdgeSweatpants-gallery-23.jpg?v=1776907692", alt: "Snow Washed Tape Raw Edge Sweatpants in taupe front view" },
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/SnowWashedTapeRawEdgeSweatpants-gallery-24.jpg?v=1776907692", alt: "Snow Washed Tape Raw Edge Sweatpants in taupe back view" }
        ]
      }
    },
    "essential-fleece-mock-neck-crew-sweatshirt": {
      default: [
        { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/EssentialFleeceMock-NeckCrewSweatshirt-gallery-20.jpg?v=1780318110", alt: "Essential Fleece Mock-Neck Crew Sweatshirt in cream front view" }
      ],
      colors: {
        cream: [{ src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/EssentialFleeceMock-NeckCrewSweatshirt-gallery-20.jpg?v=1780318110", alt: "Essential Fleece Mock-Neck Crew Sweatshirt in cream front view" }],
        white: [{ src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/EssentialFleeceMock-NeckCrewSweatshirt-gallery-16.jpg?v=1780318110", alt: "Essential Fleece Mock-Neck Crew Sweatshirt in white front view" }],
        black: [{ src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/EssentialFleeceMock-NeckCrewSweatshirt-gallery-14.jpg?v=1780318110", alt: "Essential Fleece Mock-Neck Crew Sweatshirt in black front view" }],
        pink: [{ src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/EssentialFleeceMock-NeckCrewSweatshirt-gallery-24.jpg?v=1780318111", alt: "Essential Fleece Mock-Neck Crew Sweatshirt in pink front view" }],
        yellow: [{ src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/EssentialFleeceMock-NeckCrewSweatshirt-gallery-22.jpg?v=1780318110", alt: "Essential Fleece Mock-Neck Crew Sweatshirt in yellow front view" }],
        gray: [{ src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/EssentialFleeceMock-NeckCrewSweatshirt-gallery-18.jpg?v=1780318110", alt: "Essential Fleece Mock-Neck Crew Sweatshirt in gray front view" }]
      }
    },
    "essential-drawstring-straight-leg-sweatpants": {
      default: [
        { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/EssentialDrawstringStraight-LegSweatpants-gallery-1.jpg?v=1780445484", alt: "Essential Drawstring Straight-Leg Sweatpants in gray front view" },
        { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/EssentialDrawstringStraight-LegSweatpants-gallery-2.jpg?v=1780445484", alt: "Essential Drawstring Straight-Leg Sweatpants in gray back view" }
      ],
      colors: {
        gray: [
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/EssentialDrawstringStraight-LegSweatpants-gallery-1.jpg?v=1780445484", alt: "Essential Drawstring Straight-Leg Sweatpants in gray front view" },
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/EssentialDrawstringStraight-LegSweatpants-gallery-2.jpg?v=1780445484", alt: "Essential Drawstring Straight-Leg Sweatpants in gray back view" }
        ],
        white: [
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/EssentialDrawstringStraight-LegSweatpants-gallery-16.jpg?v=1780445484", alt: "Essential Drawstring Straight-Leg Sweatpants in white front view" },
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/EssentialDrawstringStraight-LegSweatpants-gallery-17.jpg?v=1780445484", alt: "Essential Drawstring Straight-Leg Sweatpants in white back view" }
        ],
        black: [
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/EssentialDrawstringStraight-LegSweatpants-gallery-14.jpg?v=1780445485", alt: "Essential Drawstring Straight-Leg Sweatpants in black front view" },
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/EssentialDrawstringStraight-LegSweatpants-gallery-15.jpg?v=1780445484", alt: "Essential Drawstring Straight-Leg Sweatpants in black back view" }
        ],
        purple: [
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/EssentialDrawstringStraight-LegSweatpants-gallery-20.jpg?v=1780445484", alt: "Essential Drawstring Straight-Leg Sweatpants in purple front view" },
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/EssentialDrawstringStraight-LegSweatpants-gallery-21.jpg?v=1780445484", alt: "Essential Drawstring Straight-Leg Sweatpants in purple back view" }
        ]
      }
    },
    "womens-contrast-stripe-track-shorts": {
      default: [
        { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/Women_sContrastStripeTrackShorts-gallery-16.jpg?v=1780338972", alt: "Women's Contrast Stripe Track Shorts in white front view" },
        { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/Women_sContrastStripeTrackShorts-gallery-17.jpg?v=1780338972", alt: "Women's Contrast Stripe Track Shorts in white back view" }
      ],
      colors: {
        white: [
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/Women_sContrastStripeTrackShorts-gallery-16.jpg?v=1780338972", alt: "Women's Contrast Stripe Track Shorts in white front view" },
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/Women_sContrastStripeTrackShorts-gallery-17.jpg?v=1780338972", alt: "Women's Contrast Stripe Track Shorts in white back view" }
        ],
        black: [
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/Women_sContrastStripeTrackShorts-gallery-14.jpg?v=1780338972", alt: "Women's Contrast Stripe Track Shorts in black front view" },
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/Women_sContrastStripeTrackShorts-gallery-15.jpg?v=1780338972", alt: "Women's Contrast Stripe Track Shorts in black back view" }
        ],
        blue: [
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/Women_sContrastStripeTrackShorts-gallery-18.jpg?v=1780338972", alt: "Women's Contrast Stripe Track Shorts in blue front view" },
          { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/Women_sContrastStripeTrackShorts-gallery-19.jpg?v=1780338972", alt: "Women's Contrast Stripe Track Shorts in blue back view" }
        ]
      }
    },
    "contrast-stripes-bodycon-raglan-sleeve-t-shirt": {
      default: [
        { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/ContrastStripesBodyconRaglanSleeveT-Shirt-gallery-17.jpg?v=1780316112", alt: "Contrast Stripes Bodycon Raglan Sleeve T-Shirt in cream front view" }
      ],
      colors: {
        cream: [{ src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/ContrastStripesBodyconRaglanSleeveT-Shirt-gallery-17.jpg?v=1780316112", alt: "Contrast Stripes Bodycon Raglan Sleeve T-Shirt in cream front view" }],
        beige: [{ src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/ContrastStripesBodyconRaglanSleeveT-Shirt-gallery-20.jpg?v=1780316112", alt: "Contrast Stripes Bodycon Raglan Sleeve T-Shirt in beige front view" }],
        brown: [{ src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/ContrastStripesBodyconRaglanSleeveT-Shirt-gallery-14.jpg?v=1780316112", alt: "Contrast Stripes Bodycon Raglan Sleeve T-Shirt in brown front view" }],
        white: [{ src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/ContrastStripesBodyconRaglanSleeveT-Shirt-gallery-1.jpg?v=1780316113", alt: "Contrast Stripes Bodycon Raglan Sleeve T-Shirt in white front view" }]
      }
    },
    "vintage-wash-heavyweight-denim-jeans": {
      default: [
        { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/VintageWashHeavyweightDenimJeans-gallery-1.jpg?v=1776274751", alt: "Vintage Wash Heavyweight Denim Jeans front view" },
        { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/VintageWashHeavyweightDenimJeans-gallery-2.jpg?v=1776274751", alt: "Vintage Wash Heavyweight Denim Jeans back view" },
        { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/VintageWashHeavyweightDenimJeans-gallery-3.jpg?v=1776274751", alt: "Vintage Wash Heavyweight Denim Jeans detail view" }
      ],
      colors: {}
    },
    "essential-heavyweight-boxy-fleece-hoodie": {
      default: [
        { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/EssentialHeavyweightBoxyFleeceHoodie-gallery-1.jpg?v=1776374913", alt: "Essential Heavyweight Boxy Fleece Hoodie front view" },
        { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/EssentialHeavyweightBoxyFleeceHoodie-gallery-2.jpg?v=1776374913", alt: "Essential Heavyweight Boxy Fleece Hoodie back view" },
        { src: "https://cdn.shopify.com/s/files/1/0758/4618/9211/files/EssentialHeavyweightBoxyFleeceHoodie-gallery-17.jpg?v=1776374913", alt: "Essential Heavyweight Boxy Fleece Hoodie worn front view" }
      ],
      colors: {}
    }
  };

  const normalizeOption = (value) => value.toLowerCase().trim();

  const getProductGalleryImages = (handle, color) => {
    const gallery = productGalleries[handle];

    if (!gallery) {
      return [];
    }

    const colorKey = color ? normalizeOption(color) : "";
    return gallery.colors[colorKey] || gallery.default || [];
  };

  const dailyVerses = [
    { text: '"Be still, and know that I am God."', source: "Psalm 46:10" },
    { text: '"I can do all things through Christ which strengtheneth me."', source: "Philippians 4:13" },
    { text: '"Trust in the Lord with all thine heart."', source: "Proverbs 3:5" },
    { text: '"With God all things are possible."', source: "Matthew 19:26" },
    { text: '"Let all that you do be done in love."', source: "1 Corinthians 16:14" },
    { text: '"The joy of the Lord is your strength."', source: "Nehemiah 8:10" },
    { text: '"The Lord is my shepherd; I shall not want."', source: "Psalm 23:1" },
    { text: '"He hath made every thing beautiful in his time."', source: "Ecclesiastes 3:11" }
  ];

  const dayOfYear = (date) => {
    const start = new Date(date.getFullYear(), 0, 0);
    return Math.floor((date - start) / 86400000);
  };

  const verseText = document.querySelector(".simple-verse .inspiration-text, #daily-verse-text");
  const verseSource = document.querySelector(".simple-verse .inspiration-source, #daily-verse-source");
  const verseForToday = dailyVerses[dayOfYear(new Date()) % dailyVerses.length];

  if (verseText && verseSource) {
    verseText.textContent = verseForToday.text;
    verseSource.textContent = verseForToday.source;
  }

  document.querySelectorAll(".reveal").forEach((element) => {
    element.classList.add("is-visible");
  });

  document.querySelectorAll(".js-product-form").forEach((form) => {
    const variantScript = form.querySelector("[data-product-variants]");
    const variantInput = form.querySelector("[data-variant-id]");
    const priceTarget = document.querySelector("[data-product-price]");
    const addToCartButton = form.querySelector("[data-add-to-cart]");
    const productDetail = form.closest(".product-detail");
    const gallery = productDetail ? productDetail.querySelector("[data-product-gallery]") : null;
    const galleryMain = gallery ? gallery.querySelector(".product-gallery-main") : null;
    const galleryThumbs = gallery ? gallery.querySelector("[data-gallery-thumbs]") : null;
    const productHandle = gallery ? gallery.dataset.productHandle : "";

    if (!variantScript || !variantInput) {
      return;
    }

    const variants = JSON.parse(variantScript.textContent);
    const optionInputs = form.querySelectorAll("[data-option-index]");
    const optionGroups = form.querySelectorAll(".option-group");
    const optionIndexes = Array.from(
      new Set(Array.from(optionInputs).map((input) => input.dataset.optionIndex))
    ).sort((first, second) => Number(first) - Number(second));

    const getSelectedValueForIndex = (index) => {
      const inputs = Array.from(optionInputs).filter((input) => input.dataset.optionIndex === index);
      const checkedInput = inputs.find((input) => input.checked);
      const selectInput = inputs.find((input) => input.tagName === "SELECT");

      if (checkedInput) {
        return checkedInput.value;
      }

      return selectInput ? selectInput.value : "";
    };

    const getSelectedColor = () => {
      let selectedColor = "";

      optionGroups.forEach((group) => {
        const legend = group.querySelector("legend");
        const input = group.querySelector("[data-option-index]:checked") || group.querySelector("[data-option-index]");

        if (legend && input && /colou?r/i.test(legend.textContent)) {
          selectedColor = input.value;
        }
      });

      return selectedColor;
    };

    const isColorInput = (input) => {
      const group = input.closest(".option-group");
      const legend = group ? group.querySelector("legend") : null;

      return Boolean(legend && /colou?r/i.test(legend.textContent));
    };

    const scrollToGallery = () => {
      if (!gallery) {
        return;
      }

      const headerOffset = 90;
      const galleryTop = gallery.getBoundingClientRect().top + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: Math.max(galleryTop, 0),
        behavior: "smooth",
      });
    };

    const requestGalleryScroll = () => {
      window.setTimeout(scrollToGallery, 120);
      window.setTimeout(scrollToGallery, 360);
    };

    const renderGallery = (images) => {
      if (!galleryMain || images.length === 0) {
        return;
      }

      const setActiveImage = (image, thumb) => {
        galleryMain.removeAttribute("srcset");
        galleryMain.src = image.src;
        galleryMain.alt = image.alt || galleryMain.alt;

        if (galleryThumbs && thumb) {
          galleryThumbs.querySelectorAll("img").forEach((imageThumb) => {
            imageThumb.classList.remove("is-active");
          });
          thumb.classList.add("is-active");
        }
      };

      setActiveImage(images[0]);

      if (!galleryThumbs) {
        return;
      }

      galleryThumbs.innerHTML = "";

      images.slice(0, 3).forEach((image, index) => {
        const thumb = document.createElement("img");
        thumb.src = image.src;
        thumb.alt = image.alt || galleryMain.alt;
        thumb.loading = "lazy";
        thumb.width = 480;
        thumb.height = 480;

        if (index === 0) {
          thumb.classList.add("is-active");
        }

        thumb.addEventListener("click", () => {
          setActiveImage(image, thumb);
        });

        galleryThumbs.appendChild(thumb);
      });
    };

    const syncGallery = (matchedVariant) => {
      const colorImages = getProductGalleryImages(productHandle, getSelectedColor());

      if (colorImages.length > 0) {
        renderGallery(colorImages);
        return;
      }

      const variantImage = matchedVariant && matchedVariant.featured_image && matchedVariant.featured_image.src;

      if (variantImage) {
        renderGallery([{ src: variantImage, alt: matchedVariant.featured_image.alt || galleryMain.alt }]);
      }
    };

    const syncVariant = ({ scrollAfterColorChange = false } = {}) => {
      const selectedOptions = optionIndexes.map(getSelectedValueForIndex);
      const matchedVariant = variants.find((variant) =>
        variant.options.every((option, index) => option === selectedOptions[index])
      );

      if (!matchedVariant) {
        if (addToCartButton) {
          addToCartButton.disabled = true;
          addToCartButton.textContent = "Unavailable";
        }
        return;
      }

      variantInput.value = matchedVariant.id;
      syncGallery(matchedVariant);

      if (scrollAfterColorChange) {
        requestGalleryScroll();
      }

      if (priceTarget) {
        priceTarget.textContent = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD"
        }).format(matchedVariant.price / 100);
      }

      if (addToCartButton) {
        addToCartButton.disabled = !matchedVariant.available;
        addToCartButton.textContent = matchedVariant.available ? "Add To Cart" : "Sold Out";
      }
    };

    optionInputs.forEach((input) => {
      input.addEventListener("click", () => {
        if (isColorInput(input)) {
          requestGalleryScroll();
        }
      });

      input.addEventListener("change", () => {
        syncVariant({ scrollAfterColorChange: isColorInput(input) });
      });
    });

    syncVariant();
  });
});
